import React from 'react';

const BADGE_NAMES = {
  T: 'Transport',
  P: 'Playmaker',
  S: 'Scorer',
};

const SIZES = {
  small: 'player-type-badge player-type-badge-sm',
  normal: 'player-type-badge',
  large: 'player-type-badge player-type-badge-lg',
};

export function getPlayerTypeBadge(player) {
  if (!player.SK || !player.PH || !player.PA || !player.DF || !player.SC) return null;

  const toughValue = player.SK * 0.75 + player.PH * 0.25;
  const playmakerValue = player.PA * 0.75 + player.DF * 0.25;
  const scorerValue = player.SC;
  const maxValue = Math.max(toughValue, playmakerValue, scorerValue);

  if (maxValue === toughValue) return 'T';
  if (maxValue === playmakerValue) return 'P';
  if (maxValue === scorerValue) return 'S';
  return 'T';
}

export default function PlayerTypeBadge({ player, size = 'normal' }) {
  const badge = getPlayerTypeBadge(player);
  if (!badge) return null;

  return (
    <span
      className={`${SIZES[size] || SIZES.normal} player-type-${badge.toLowerCase()}`}
      title={BADGE_NAMES[badge]}
    >
      {badge}
    </span>
  );
}
